// Defaults for the HTTP integration
export const HTTP_INTEGRATION_DEFAULT_TIMEOUT_IN_SECONDS = 300;
export const HTTP_INTEGRATION_DEFAULT_RETRY_COUNT = 3;
